export enum ProjectType {
	WorkContract = 0,
	TemporaryEmployment = 1,
}
